import React from "react";
import BrandFormField from "./BrandFormField";
import EditableText from "./EditableText";
import { type AxiosResponse } from "axios";
import { type UseMutationResult } from "@tanstack/react-query";

interface Props<T> {
  brand: server.dto.Brand
  title?: string
  explanation: string
  maxLength: number
  initialText: string
  useMutation: () => UseMutationResult<AxiosResponse<server.dto.ApiResponse>, unknown, T, unknown>
  createInstruction: (textValue: string) => T
}

const BrandInputField = <T extends unknown>(props: Props<T>) => {
  const api = props.useMutation();

  const onSave = async (newValue: string) => {
    const res = await api.mutateAsync(props.createInstruction(newValue));

    return !res.data.hasErrors;
  };

  const errors = api.isSuccess ? api.data.data.errors : [];
  const hasErrors = errors.length > 0;

  return <BrandFormField label={props.title}>
    <EditableText
      maxLength={props.maxLength}
      initialText={props.initialText}
      onSave={onSave}
    />
    {!hasErrors && <div className="margin-top-mini">
      {props.explanation}
    </div>}
    {hasErrors && <div className="margin-top-mini red">
      {errors.map((e) => <div key={e.message}>{e.message}</div>)}
    </div>}
  </BrandFormField>;
};

export default BrandInputField;